// TypingIndicator Component
// Based on documentation from docs/03_CHAT_MESSAGING_SYSTEM.md

import React from 'react';
import '../styles/TypingIndicator.css';

const TypingIndicator = ({ users }) => {
  if (!users || users.length === 0) return null;

  const typingNames = users.map(u => u.peerName || u.userName || u.initial || 'Someone').join(', ');
  const text = users.length === 1 
    ? `${typingNames} is typing...` 
    : `${typingNames} are typing...`;

  return (
    <div className="typing-indicator">
      <span className="typing-text">{text}</span>
      <div className="typing-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default TypingIndicator;
